import { useCart } from '@/contexts/CartContext';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export default function FloatingCart() {
  const { totalItems, openCart } = useCart();
  const { t } = useTranslation();
  const location = useLocation();

  // /lp/* ad landing pages are deliberately distraction-free — no floating
  // cart icon inviting a click away from the page's own single CTA.
  if (location.pathname.includes('/admin') || location.pathname.includes('/lp/')) return null;

  return (
    <button
      onClick={openCart}
      className="fixed bottom-24 right-4 z-[45] w-12 h-12 rounded-full bg-[#7B1113] text-white flex items-center justify-center shadow-lg hover:bg-[#5C0D0F] transition-colors cursor-pointer md:bottom-8"
      aria-label={t('nav.cart')}
    >
      <div className="w-5 h-5 flex items-center justify-center">
        <i className="ri-shopping-bag-line text-lg"></i>
      </div>
      {totalItems > 0 && (
        <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-white text-[#7B1113] text-[10px] font-bold flex items-center justify-center border border-[#7B1113]">
          {totalItems > 9 ? '9+' : totalItems}
        </span>
      )}
    </button>
  );
}